import React from 'react'
import {Icon} from 'common/Icon'
import styles from './FullscreenButton.scss'

export class FullscreenButton extends React.PureComponent {
  render () {
    const {isFullscreen, onClick} = this.props
    return (
      <div className={styles.FullscreenButton}>
        <button onClick={onClick}>
          <Icon i={isFullscreen ? 'md-contract' : 'md-expand'} />{isFullscreen ? ' Exit ' : ' '}Fullscreen
        </button>
      </div>
    )
  }
}
